module.exports = __webpack_public_path__ + "static/media/Strength of Materials.14beaf0b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MECH/Strength of Materials.pdf
// module id = 145
// module chunks = 0